import React, { useState, useEffect } from 'react';
import { Col, Container, Row } from 'react-bootstrap';

export default function Footer() {
  const [version, setVersion] = useState('1.0.0.0');

  useEffect(() => {
    // Buscar versão atual do version.json
    const fetchVersion = async () => {
      try {
        const response = await fetch(`/version.json?t=${Date.now()}`);
        const versionData = await response.json();
        if (versionData.version) {
          setVersion(versionData.version);
        }
      } catch (error) {
        console.log('Usando versão padrão no rodapé');
      }
    };

    fetchVersion();
  }, []);

  return (
    <footer className="footer bg-white shadow align-self-end py-3 px-xl-5 w-100">
      <Container fluid>
        <Row>
          <Col md={6} className="text-center text-md-start fw-bold">
            <p className="mb-2 mb-md-0">OpenNew Telecomunicações</p>
          </Col>
          <Col md={6} className="text-center text-md-end text-gray-400">
            <p className="mb-0">Versão {version} - Desenvolvido por OpenNew</p>
          </Col>
        </Row>
      </Container>
    </footer>
  );
}
